function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6 4a1 1 0 00-1 1v10a5 5 0 005 5h4a5 5 0 005-5V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v10a1 1 0 01-1 1h-4a1 1 0 01-1-1V5a1 1 0 00-1-1H6z",
  fill: "silver",
  stroke: "#404040",
  strokeWidth: "1.5",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 5v10a5 5 0 005 5h4a5 5 0 005-5V5",
  stroke: "#8A8A8A",
  strokeWidth: ".5",
  strokeLinejoin: "round",
  strokeDasharray: "0.5 0.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 5v4h4V5H5z",
  fill: "#FF5252",
  stroke: "#404040",
  strokeWidth: "1.5",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 6h2",
  stroke: "#FF8A8A",
  strokeWidth: ".75",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 7.5h2",
  stroke: "#FF8A8A",
  strokeWidth: ".75",
  strokeLinecap: "round",
  strokeOpacity: ".5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 5v4h4V5h-4z",
  fill: "#4169E1",
  stroke: "#404040",
  strokeWidth: "1.5",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 6h2",
  stroke: "#8AAAFF",
  strokeWidth: ".75",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 7.5h2",
  stroke: "#8AAAFF",
  strokeWidth: ".75",
  strokeLinecap: "round",
  strokeOpacity: ".5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 6.5h2M2 8h3",
  stroke: "#404040",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 9.5h2",
  stroke: "#404040"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 6.5h-2M22 8h-3",
  stroke: "#404040",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 9.5h-2",
  stroke: "#404040"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 15s.5.5 3 .5 3-.5 3-.5M14.5 16.5s-.3 1-.5 1.5-.5 1-.5 1M10.5 16.5s.3 1 .5 1.5.5 1 .5 1",
  stroke: "#fff",
  strokeWidth: ".5",
  strokeOpacity: ".7"
})));